import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_MEDIAS = "/api/medias"

export async function getMedias(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_MEDIAS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getMedia(id) {
  let url = REACT_APP_API_URL + ENDPOINT_MEDIAS + "/" + id
  return await getObject(url)
}

export async function putMedia(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_MEDIAS + "/" + id
  return await putObject(url, putValues)
}

export async function patchMedia(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_MEDIAS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postMedia(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_MEDIAS
  return await postObject(url, postValues)
}
